import { Actions, ActionTypes } from './actions';
import { CustomerRef, Discount } from '../../types/discounts';

export interface State {
    isLoading: boolean;
    error: boolean;
    discount: Discount | undefined;
    discountCustomers: CustomerRef[] | undefined;
}

export const initialState: State = {
    isLoading: false,
    error: false,
    discount: undefined,
    discountCustomers: undefined,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.FetchDiscount:
            return {
                ...state,
                discount: undefined,
                isLoading: true,
            };

        case ActionTypes.FetchDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                discount: action.payload,
            };

        case ActionTypes.ClearFetchedData:
            return {
                isLoading: false,
                error: false,
                discount: undefined,
                discountCustomers: undefined,
            };

        case ActionTypes.UpdateDiscount:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.UpdateDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        case ActionTypes.DeleteDiscount:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.DeleteDiscountResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
            };

        case ActionTypes.FetchDiscountCustomersResponse:
            return {
                ...state,
                discountCustomers: action.payload,
            };

        case ActionTypes.RemoveDiscountImageAsset:
            return {
                ...state,
                discount: state.discount
                    ? {
                        ...state.discount,
                        links: state.discount.links
                            ? state.discount.links.filter((x) => x.rel !== 'thumbnail_discount_image')
                            : undefined,
                    }
                    : undefined,
            };

        case ActionTypes.CreateAsset:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.UploadAssetResponse:
            return {
                ...state,
                isLoading: false,
                discount: state.discount
                    ? {
                        ...state.discount,
                        links: state.discount.links
                            ? [
                                ...state.discount.links,
                                {
                                    rel: 'thumbnail_discount_image',
                                    href: action.meta.cause.payload.publicUrl,
                                },
                            ]
                            : undefined,
                    }
                    : undefined,
            };

        default:
            return state;
    }
}
